/*
 * File: OverviewTab.tsx
 * Project: a-a
 * File Created: Saturday, 9th November 2024 9:40:29 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Monday, 13th October 2025 8:53:15 pm
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2024 Mutual Mobile, Mutual Mobile
 */
import { Box } from '@mui/material';
import React, { ReactElement, useState } from 'react';
import CustomLoader from '../../CustomLoader/CustomLoader';
import SocialEngagement from './SocialEngagement';

const OverviewTab = ({
  setActiveTab,
  Column1,
  Column2,
  Column3,
  Column4,
  creatorInfo,
  AlternatColumn3,
  setValue,
  captive8Url,
  captive8Loading,
  path,
  channelID,
}: {
  setActiveTab: React.Dispatch<React.SetStateAction<number>>;
  creatorInfo?: any;
  channelID?: string;
  Column1: React.ComponentType<{
    setTabLoading: React.Dispatch<React.SetStateAction<boolean>>;
    setActiveTab: React.Dispatch<React.SetStateAction<number>>;
    channelID?: string;
  }>;
  Column2: React.ComponentType<{
    setTabLoading: React.Dispatch<React.SetStateAction<boolean>>;
    setActiveTab: React.Dispatch<React.SetStateAction<number>>;
    setValue?: React.Dispatch<React.SetStateAction<number>> | undefined;
  }>;
  Column3: React.ComponentType<{
    setTabLoading: React.Dispatch<React.SetStateAction<boolean>>;
    path?: string;
  }>;
  AlternatColumn3?: React.ComponentType<{
    setTabLoading: React.Dispatch<React.SetStateAction<boolean>>;
    creatorInfo?: any;
    setValue?: any;
    captive8Url?: any;
    captive8loading?: boolean;
  }>;
  Column4: React.ComponentType<{
    setValue?: React.Dispatch<React.SetStateAction<number>> | undefined;
  }>;
  setValue?: React.Dispatch<React.SetStateAction<number>>;
  captive8Url?: any;
  captive8Loading?: boolean;
  path?: string;
}) => {
  const [loading, setLoading] = useState(true);
  console.log({ captive8Url });
  return (
    <Box
      sx={{
        display: 'flex',
        gap: { xs: '20px', xl: '32px' },
        width: '100%',
        flex: 1,
        height: '100vh',
        // padding: '10px 0px 0px 0px',
        // overflowX: 'auto',
      }}
    >
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          width: 'calc(33.333% - 27px)',
        }}
      >
        {/* <ActivityColumn setActiveTab={setActiveTab} setTabLoading={setLoading} /> */}
        <Column1 setActiveTab={setActiveTab} setTabLoading={setLoading} channelID={channelID} />
      </Box>
      <Box
        sx={{ flex: 1, display: 'flex', flexDirection: 'column', width: 'calc(33.333% - 27px)' }}
      >
        {/* <TaskColumn setActiveTab={setActiveTab} setTabLoading={setLoading} /> */}
        <Column2 setActiveTab={setActiveTab} setTabLoading={setLoading} setValue={setValue} />
      </Box>
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          gap: '24px',
          width: 'calc(33.333% - 27px)',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            // height: '30vh',
            // overflowY: 'scroll',
          }}
        >
          {/* <AccountColumn setTabLoading={setLoading} /> */}
          {(creatorInfo || captive8Url || captive8Loading) && AlternatColumn3 && setValue ? (
            <AlternatColumn3
              captive8loading={captive8Loading}
              setTabLoading={setLoading}
              creatorInfo={creatorInfo}
              setValue={setValue}
              captive8Url={captive8Url}
            />
          ) : (
            <Column3 setTabLoading={setLoading} path={path || ''} />
          )}
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',

            // height: '27vh',
            // overflowY: 'scroll',
          }}
        >
          {/* <TodaysMeeting /> */}
          <Column4 setValue={setValue} />
        </Box>
      </Box>
      {/* {loading ? (
        <CustomLoader
          open={loading}
          // handleCloseModal={() => {
          //   setLoading(false);
          // }}
        />
      ) : (
        ''
      )} */}
    </Box>
  );
};

export default OverviewTab;
